import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';

declare global {
  // Add global flags to prevent emulator reconnection
  var __FIREBASE_AUTH_EMULATOR_CONNECTED__: boolean | undefined;
  var __FIREBASE_FIRESTORE_EMULATOR_CONNECTED__: boolean | undefined;
}

const firebaseConfig = {
  apiKey: import.meta.env.VITE_API_KEY,
  authDomain: import.meta.env.VITE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_APP_ID,
  measurementId: import.meta.env.VITE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Environment settings
const isLocalEnvironment = import.meta.env.VITE_ENVIRONMENT === 'local';

// Auth configuration
if (isLocalEnvironment) {
  // Only connect to emulators if not already connected (prevents hot reload errors)
  if (!globalThis.__FIREBASE_AUTH_EMULATOR_CONNECTED__) {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099');
    globalThis.__FIREBASE_AUTH_EMULATOR_CONNECTED__ = true;
  }
  if (!globalThis.__FIREBASE_FIRESTORE_EMULATOR_CONNECTED__) {
    connectFirestoreEmulator(db, '127.0.0.1', 7002);
    globalThis.__FIREBASE_FIRESTORE_EMULATOR_CONNECTED__ = true;
  }
}

export const checkLoginStatus = () =>
  new Promise<boolean>((resolve) => {
    onAuthStateChanged(auth, (user) => {
      resolve(!!user);
    });
  });

export { app };
export default app;
